// src/components/ReadjudicacionMasiva/Documentos/OpcionesImpresion.js

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
    Paper,
    Typography,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField,
    Grid,
    Box,
    Divider
} from '@mui/material';
import {
    Print as PrintIcon
} from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3)
    },
    title: {
        fontWeight: 600,
        marginBottom: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1)
    },
    section: {
        marginBottom: theme.spacing(3)
    },
    sectionTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.main
    },
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    formControl: {
        width: '100%'
    }
}));

const OpcionesImpresion = ({ opciones, onChange }) => {
    const classes = useStyles();

    const handleChange = (campo) => (event) => {
        onChange({
            ...opciones,
            [campo]: event.target.value
        });
    };

    return (
        <Paper className={classes.paper}>
            <Typography variant="h6" className={classes.title}>
                <PrintIcon color="primary" />
                Opciones de Impresión
            </Typography>

            {/* Formato de salida */}
            <Box className={classes.section}>
                <Typography variant="subtitle2" className={classes.sectionTitle}>
                    Formato de Salida
                </Typography>
                <FormControl component="fieldset" className={classes.formControl}>
                    <RadioGroup
                        value={opciones.formato || 'PDF'}
                        onChange={handleChange('formato')}
                    >
                        <FormControlLabel
                            value="PDF"
                            control={<Radio color="primary" />}
                            label="PDF - Archivo único consolidado"
                        />
                        <FormControlLabel
                            value="PDF_INDIVIDUAL"
                            control={<Radio color="primary" />}
                            label="PDF Individual - Un archivo por registro"
                        />
                        <FormControlLabel
                            value="WORD"
                            control={<Radio color="primary" />}
                            label="Word - Documento editable"
                            disabled
                        />
                    </RadioGroup>
                </FormControl>
            </Box>

            <Divider className={classes.divider} />

            {/* Ordenamiento */}
            <Box className={classes.section}>
                <Typography variant="subtitle2" className={classes.sectionTitle}>
                    Ordenamiento
                </Typography>
                <FormControl component="fieldset" className={classes.formControl}>
                    <RadioGroup
                        value={opciones.ordenamiento || 'FILA'}
                        onChange={handleChange('ordenamiento')}
                    >
                        <FormControlLabel
                            value="FILA"
                            control={<Radio color="primary" />}
                            label="Por Fila - Orden del archivo original"
                        />
                        <FormControlLabel
                            value="NOMBRE"
                            control={<Radio color="primary" />}
                            label="Por Nombre - Alfabéticamente"
                        />
                        <FormControlLabel
                            value="DNI"
                            control={<Radio color="primary" />}
                            label="Por DNI/CUIT - Numérico"
                        />
                        <FormControlLabel
                            value="JUZGADO"
                            control={<Radio color="primary" />}
                            label="Por Juzgado - Agrupado"
                        />
                    </RadioGroup>
                </FormControl>
            </Box>

            <Divider className={classes.divider} />

            {/* Opciones adicionales */}
            <Box className={classes.section}>
                <Typography variant="subtitle2" className={classes.sectionTitle}>
                    Opciones Adicionales
                </Typography>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label="Copias por Documento"
                            type="number"
                            value={opciones.copias || 1}
                            onChange={handleChange('copias')}
                            variant="outlined"
                            size="small"
                            fullWidth
                            InputProps={{
                                inputProps: { min: 1, max: 10 }
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormLabel component="legend" style={{ fontSize: '0.875rem', marginBottom: 8 }}>
                                Orientación
                            </FormLabel>
                            <RadioGroup
                                value={opciones.orientacion || 'VERTICAL'}
                                onChange={handleChange('orientacion')}
                                row
                            >
                                <FormControlLabel
                                    value="VERTICAL"
                                    control={<Radio color="primary" size="small" />}
                                    label="Vertical"
                                />
                                <FormControlLabel
                                    value="HORIZONTAL"
                                    control={<Radio color="primary" size="small" />}
                                    label="Horizontal"
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid size={12}>
                        <TextField
                            label="Observaciones"
                            value={opciones.observaciones || ''}
                            onChange={handleChange('observaciones')}
                            variant="outlined"
                            size="small"
                            fullWidth
                            multiline
                            rows={2}
                            placeholder="Notas adicionales para la generación de documentos"
                        />
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default OpcionesImpresion;
